import { render, staticRenderFns } from "./ImageBgRemove.vue?vue&type=template&id=4e476f6a&scoped=true"
import script from "./ImageBgRemove.vue?vue&type=script&lang=js"
export * from "./ImageBgRemove.vue?vue&type=script&lang=js"
import style0 from "./ImageBgRemove.vue?vue&type=style&index=0&id=4e476f6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e476f6a",
  null
  
)

export default component.exports